<template>
  <el-scrollbar class="scrollinfoDv">
    <div
      class="infoPostModelSectionSelectionDv"
      v-if="enhancedRelations.length"
    >
      <template v-for="item in enhancedRelations" :key="item._id">
        <ProfileCard
          :hideActions="false"
          :fromOutside="fromOutside"
          :fromProfile="true"
          :fromInfluncersPopup="false"
          :userData="item"
          @onCardClicked="onProfileClicked"
        />
      </template>
    </div>
  </el-scrollbar>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch, computed } from "vue";
import ProfileCard from "../../../../private//dashboard/components/profile-card/ProfileCard.vue";
import { DashboardComposables } from "@/views/private/dashboard/dashboard.composables";
import storageService from "@/services/storage.service";

export default defineComponent({
  props: ["post", "fromOutside"],
  components: {
    ProfileCard,
  },
  setup(props, context) {
    const user = storageService.getUser();

    // Use DashboardComposables to get usersList with correct connection status
    const { usersList, getFilteredUser, keyword } = DashboardComposables({
      user,
    });

    const enhancedRelations = computed(() => {
      if (!props.post?.relations?.length || !usersList.value?.length) {
        return props.post?.relations || [];
      }
      // Map over post.relations and find corresponding users from usersList (which has correct connection status)
      return props.post.relations.map((relation: any) => {
        const foundUser = usersList.value.find(
          (user: any) => user._id === relation._id
        );
        if (foundUser) {
          // Only update connection status fields, keep all other relation data
          return {
            ...relation,
            isFollowing: foundUser.isFollowing || false,
            isFriend: foundUser.isFriend || false,
            requestSentData: foundUser.requestSentData || null,
            requestReceiveData: foundUser.requestReceiveData || null,
            isBlocked: foundUser.isBlocked || false,
            isReported: foundUser.isReported || false,
          };
        } else {
          // Not found in usersList - just return original relation data
          return relation;
        }
      });
    });

    const fetchUsersFromRelations = async () => {
      await getFilteredUser();
    };

    const onProfileClicked = () => {
      context.emit("onProfileClicked");
    };

    // Watch for changes in post relations and fetch users
    watch(() => props.post?.relations, fetchUsersFromRelations, {
      immediate: true,
    });

    onMounted(() => {
      fetchUsersFromRelations();
    });

    return {
      onProfileClicked,
      enhancedRelations,
    };
  },
});
</script>
<style lang="scss" scoped>
.iconDvSignalPostCreate {
  position: absolute;
  z-index: 9;
  top: -5px;
  right: -5px;
  width: 18px;
  height: auto;
  cursor: pointer;
}
.infoPostModelSectionSelectionDv {
  background: var(--base-dark);
  padding: 15px !important;
  border-radius: 10px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  flex-flow: wrap;
  gap: 20px;
  min-height: auto;
  // overflow: auto;
  height: auto;
  max-height: 450px;
  // overflow: auto;
  // @include scrollbar();
  .profileListingCardDv {
    max-width: 220px;
    width: 220px;
    flex: 0 0 220px;
    .profileListingCardBodyDv {
      z-index: 5;
    }
  }
}
</style>
